module.exports = __webpack_public_path__ + "img/img_splitter.4be6bef9.svg";